import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Tab, Tabs } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import ClientList from "./ClientList";
import LeadList from "./LeadList";
import { useFormikContext } from "formik";
import { getReferralPartnerById } from "../../../../services/ReferralPartnerService";
import GlobitsTextField from "../../../../common/form/GlobitsTextField";
import GlobitsSelectInput from "../../../../common/form/GlobitsSelectInput";
import { ReferralPartnerType, ReferralPartnerIntroducerTypeEnum, ReferralPartnerStatus } from "../../../../LocalConstants";
import GlobitsAutocomplete from "../../../../common/form/GlobitsAutocomplete";
import GlobitsDateTimePicker from "../../../../common/form/GlobitsDateTimePicker";


const defaultCollaborator = {
  id: null,
  name: null,
  code: null,
  description: null,
  phoneNumber: null,
  phoneNumber2: null,
  email: null,
  address: null,
  note: null,
  clients: [],
  leads: [],
  client: null,
  agent: null,
  partnerType: null
};



export default observer(function ReferralPartnerPopup({
  handleClose,
  open,
}) {
  const { t } = useTranslation();
  const [collaborator, setCollaborator] = useState(defaultCollaborator);
  const { values } = useFormikContext();
  useEffect(() => {
    const fetchReferralPartner = async () => {
      const id = values?.referralPartner?.id;
      if (id) {
        try {
          const { data } = await getReferralPartnerById(id);

          if (data) {
            setCollaborator(data);
          } else {
            console.warn("Không tìm thấy thông tin cộng tác viên với mã:", id);
          }
        } catch (error) {
          console.error("Lỗi khi lấy dữ liệu cộng tác viên:", error);
        }
      } else {
        console.log("Không có mã cộng tác viên để tra cứu.");
      }
    };

    fetchReferralPartner();
  }, []);


  return (
    <PopupForm
      size="md"
      open={open}
      handleClose={handleClose}
      title={"Xem chi tiết cộng tác viên"}
      formik={{
        enableReinitialize: true,
        initialValues: collaborator,
        onSubmit: handleClose,
      }}
      action={({ isSubmitting }) => (
        <>
          <Button
            startIcon={<BlockIcon />}
            className="btn btn-secondary d-inline-flex"
            onClick={handleClose}
          >
            {t("general.button.cancel")}
          </Button>
        </>
      )}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Mã cộng tác viên"}
            name="code"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsSelectInput
            label={"Hình thức CTV"}
            name="partnerType"
            options={ReferralPartnerType.getListData()}
            disabled
          />
        </Grid>
        {values?.partnerType === ReferralPartnerType.INTERNAL.value ? (
          <Grid item xs={12} sm={4} xl={3}>
            <GlobitsAutocomplete
              label="CTV là nhân viên"
              name={"referralPartnerAgent"}
              disabled
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={4} xl={3}>
            <GlobitsAutocomplete
              label={"Khách hàng"}
              name="client"
              disabled
            />
          </Grid>
        )}
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Tên cộng tác viên"}
            name="name" disabled />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Số điện thoại"}
            name="phoneNumber"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Số điện thoại 2"}
            name="phoneNumber2"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsAutocomplete
            label={"Ngân hàng"}
            name="bank"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Số tài khoản"}
            name="bankAccountNumber"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Tên Người thụ hưởng"}
            name="beneficiaryName"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsAutocomplete
            label={"Loại CTV giới thiệu"}
            name="introducerType"
            disabled
          />
        </Grid>
        {values?.type === ReferralPartnerIntroducerTypeEnum.Client.value && (
          <Grid item xs={12} sm={4} xl={3}>
            <GlobitsAutocomplete
              label="Khách hàng giới thiệu"
              name="introducer"
              disabled
            />
          </Grid>
        )}
        {values?.type === ReferralPartnerIntroducerTypeEnum.ReferralPartner.value && (
          <Grid item xs={12} sm={4} xl={3}>
            <GlobitsAutocomplete
              name={"introducer"}
              label="Cộng tác viên giới thiệu"
              disabled
            />
          </Grid>
        )}
        {values?.type === ReferralPartnerIntroducerTypeEnum.Staff.value && (
          <Grid item xs={12} sm={4} xl={3}>
            <GlobitsAutocomplete
              name={"introducer"}
              label="Nhân viên viên giới thiệu"
              disabled
            />
          </Grid>
        )}
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Email"}
            name="email"
            disabled />
        </Grid>
        <Grid item xs={12} sm={4} xl={3} className={"flex-between"}>
          <GlobitsTextField
            label={"Số CCCD"}
            name="citizenIdNumber"
            type={"number"}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsDateTimePicker
            label={"Ngày sinh"}
            name="birthDate"
            disableFuture
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsAutocomplete
            label={"Nhân viên phụ trách"}
            name="agent"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsAutocomplete
            label={"Cơ sở"}
            name="department"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3} className={"flex align-end"}>
          <GlobitsSelectInput
            label={"Trạng thái CTV"}
            name="status"
            options={ReferralPartnerStatus.getListData()}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsDateTimePicker
            label={"Ngày đăng ký"}
            name="registrationDate"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Người tạo"}
            name="createdBy"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsDateTimePicker
            label={"Ngày tạo"}
            name="createDate"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} xl={3}>
          <GlobitsTextField
            label={"Địa chỉ"}
            name="address"
            disabled />
        </Grid>
        <Grid item xs={12}>
          <GlobitsTextField
            label={"Ghi chú"}
            name="note"
            isTextArea
            rows={4}
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <TabReferralPartnerComponent />
        </Grid>
      </Grid>
    </PopupForm>
  );
}
)
  ;

// Tab panel hiển thị nội dung mỗi tab
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

// Props hỗ trợ accessibility
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Tabs component có thể truyền tabList và xử lý click
const TabComponent = ({
  tabList,
  handleChange,
  value,
  className = "",
  hideIcon,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="tabs"
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        className={`Mui-tabRootCustom non-maxWidth ${!tabList.every(i => i?.icon) ? 'bottom-0' : ''}`}
      >
        {tabList?.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            iconPosition="start"
            icon={!hideIcon ? tab?.icon : null}
            {...a11yProps(index)}
            className={`Mui-tabCustom ${className}`}
          />
        ))}
      </Tabs>
    </Box>
  );
};

// Component chính hiển thị tab khách hàng
const TabReferralPartnerComponent = observer(() => {
  const tabList = [
    {
      label: "Danh sách khách hàng",
      content: <ClientList />,
    },
    {
      label: "Danh sách KHTN",
      content: <LeadList />,
    },
  ];

  const [tabDetail, setTabDetail] = useState(0);

  const handleTabChange = (_, newValue) => {
    setTabDetail(newValue);
  };

  return (
    <Grid item xs={12}>
      <TabComponent
        value={tabDetail}
        handleChange={handleTabChange}
        tabList={tabList}
      />
      {tabList.map((tab, index) => (
        <TabPanel
          key={index}
          value={tabDetail}
          index={index}
          style={{ padding: "0px" }}
        >
          {tab.content}
        </TabPanel>
      ))}
    </Grid>
  );
});